<template>
  <a-layout class="main-layout" :class="{'no-footer-layout': !showFooter && !showHeatmap}">
    <a-layout-sider class="left-menu" width="215" v-if="!hiddenMenu">
      <left-menu v-if="isBeta" @change="menuChange"></left-menu>
      <left-menu v-else-if="isYuer" @change="menuChange"></left-menu>
      <template v-else>
        <left-menu-v2 v-if="!showHeatmap" @change="menuChange"></left-menu-v2>
        <template v-else>
          <left-menu v-show="showReportData" @change="menuChange"></left-menu>
          <left-menu-v2 v-show="!showReportData" @change="menuChange"></left-menu-v2>
        </template>
      </template>
    </a-layout-sider>
    <a-layout class="right-main" :class="{'promotion-page': currentComponent === 'promotion', 'auto-height': showFooter}">
      <a-layout-content id='right-container'>
         <demo-login></demo-login> 
         <component :is="currentComponent" :url="url" @menuChange="menuChange" @itemClick="itemClick" @setMainContent="setMainContent"
         :afficheId="afficheId"></component>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
  import { Layout, Icon } from 'ant-design-vue'
  // import {getCookie, setCookie} from "@/utils/utils";
  import OutLink from "../template/out-link"
  import Promotion from '../template/promotion'
  import HomeIndex from "./home"
  import LeftMenu from "./menu"
  import LeftMenuV2 from './menuV2.vue'
  import AnnounceList from './announceInfo/newAnnounceList'
  import AnnounceDetails from './announceInfo/newAnnounceDetails'
  import global from '@/mixins/global'
  import { mapState, mapActions } from 'vuex'
  import Demologin from '@/components/demo-login'

  const { Sider, Content } = Layout
  export default {
    name: "home-main",
    components: {
      [LeftMenu.name]: LeftMenu,
      [LeftMenuV2.name]: LeftMenuV2,
      HomeIndex,
      OutLink,
      Promotion,
      [Layout.name]: Layout,
      [Sider.name]: Sider,
      [Content.name]: Content,
      [Icon.name]: Icon,
      AnnounceList,
      AnnounceDetails,
      [Demologin.name]: Demologin,
    },
    mixins: [global],
    data() {
      return {
        currentComponent: HomeIndex,
        url: '',
        TEMPLATE_ENUM: {
          'promotion': ''
        },
        afficheId:'',
        isBeta: process.env.VUE_APP_SEVERENV === 'BETA'
      }
    },
    watch: {
      currentComponent(val) {
        if (val === 'outLink' || val === 'promotion' ) {
          this.$store.commit('setShowFooter', false)
        } else {
          this.$store.commit('setShowFooter', true)
        }
      },
      $route(to, from) {
        const {query: fromQuery} = from
        const {query: toQuery} = to
        if(fromQuery && fromQuery.component && toQuery && !toQuery.component){
          this.currentComponent = HomeIndex
        } else if(toQuery && toQuery.component){
          this.currentComponent = toQuery.component
        }
      }
    },
    computed: {
       ...mapState('heatmap', ['jumpToken']),
      showFooter() {
        return this.$store.state.showFooter
      },
      hiddenMenu() {
        return this.$route.query.hide === true || this.$route.query.hide === 'true'
      },
      isYuer() {
        let buzzType = this.$cookie.get("buzzType") || ""
        return +buzzType === 5 || +buzzType === 6
      },
      ...mapState('heatmap', ['showReportData'])
    },
    mounted () {
      const url = this.$route.query.link || ''
      /*外部链接跳公告详情页面 --- start*/
      const afficheId = this.$route.query.afficheId || ''
      if (afficheId) {
        this.currentComponent = 'AnnounceDetails'
        this.afficheId = afficheId
      }
      /*外部链接跳公告详情页面 --- end*/
      if (url == 'promotion') {
        this.currentComponent = 'promotion'
      } else if (url) {
        this.currentComponent = 'outLink'
      }
      this.url = url || ''
      this.$store.commit('setSpinning', false)
    },
    methods: {
       ...mapActions('heatmap', ['getTopUser', 'getJumpToken']),
      setMainContent({component, afficheId}) {
        const {name, query, params, meta} = this.$route
        this.$router.push({
          name,
          query:{
            ...query,
            component
          },
          params,
          meta
        })
        this.currentComponent = component
        this.afficheId = afficheId
      },
      itemClick (link) {
        this.innerReffer(link)
      },
      async menuChange (item) {
        const { openKeys, selectedKeys, info = {} } = item
        // 是否外链
        if (info && info.isMarketing) {
           await this.getJumpToken() 
         if(this.jumpToken) {
          const newLink =`https://cjy-front.cekid.com/rmc-bridge/middle?redirect=${encodeURIComponent(info.link)}&token=${this.jumpToken}`
          const devLink = `https://cjy-rmc-bridge.cekid.com/rmc-bridge/middle?redirect=${encodeURIComponent(info.link)}&token=${this.jumpToken}`
          const jumpLink = process.env.VUE_APP_SEVERENV === 'BETA' ? devLink : newLink
          this.$openLink(jumpLink)
          return
        }}
        if (info && info.blankLink) {
          this.$openLink(info.link)
        } else {
          this.innerReffer(item.link || info.link, openKeys, selectedKeys, info.randomParam)
        }
      },
      /**
       *
       * @param link 跳转链接
       * @param openKeys<Array> 展开菜单集合
       * @param selectedKeys<Array> 选中集合
       */
      innerReffer (link, openKeys, selectedKeys, randomParam = true) {
        // 内部组件
        const innerComponents = [ 'promotion' ]
        const isInnerComponent = innerComponents.some(v => link === v)
        const url = isInnerComponent ? '' : link
        if (randomParam) {
          if (url && url.includes('?')) {
            this.url = `${url}&t=${new Date().getTime()}`
          } else {
            this.url = `${url}?t=${new Date().getTime()}`
          }
        } else {
          this.url = url
        }
        // 非外链记录点击记录
        this.currentComponent = isInnerComponent ? link : 'outLink'
        // 记录history信息存入cookie
        // this.$nextTick(() => {
        //   setCookie('history_url', this.url, { expires: 30 })
        //   setCookie('history_currentComponent', this.currentComponent, { expires: 30 })
        //   // 记录左侧菜单变动
        //   if (openKeys && selectedKeys) {
        //     setCookie('history_openKeys', JSON.stringify(openKeys), { expires: 30 })
        //     setCookie('history_selectedKeys', JSON.stringify(selectedKeys), { expires: 30 })
        //   }
        // })
      }
    }
  }
</script>

<style lang="scss">
.main-layout {
  /* width: 1366px;
  margin: 0 auto; */
  display:flex;
  padding: 0;
  background: #f7f7f7;
  min-height: calc(100vh - 180px);
  .left-menu {
    padding: 15px 0 15px 15px;
    background: transparent;
    // overflow: hidden;
  }
  .right-main {
    flex:1;
    padding: 15px;
    // padding-bottom: 0;
    height: 100%;
    min-height: calc(100vh - 180px);
    background: transparent;

    &.auto-height{
      min-height: unset;
    }
    // overflow: hidden !important;
    // min-height: 100%;
    /* @media screen and (max-width: 1280px) {
      min-width: 1080px;
    } */
    .ant-layout-content{
      height: auto;
      min-height: calc(100vh - 90px);
      // overflow-y: auto;
    }
    .page-iframe {
      width: 100%;
      // height: 100%;
      min-height: calc(100vh - 90px - 51px); // 90px为顶部导航加主页面上线各15px间距  51px为面包屑导航及下边距
    }
  }
}
.no-footer-layout{
  margin-top: 60px;
  height: calc(100vh - 60px);
  /* .left-menu{
    overflow: hidden;
  } */
  .right-main {
    overflow: hidden !important;

    // .ant-layout-content{
    //   overflow-y: hidden;
    // }
    &.promotion-page{
      // overflow-y: auto !important;
        .ant-layout-content{
          overflow-y: auto;
        }
    }
  }
}
</style>
<style>
.ant-layout-sider-children {
  background: #ffffff;
  min-height: 100%;
  height: auto;
}
</style>
